import React from "react";

const MonthGrid = ({ employees, assignments, monthStart }) => {
  const year = monthStart.getFullYear();
  const month = monthStart.getMonth();

  // Start from first day of month
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0); // last day of month

  const startDayOfWeek = firstDay.getDay(); // Sunday = 0

  const totalCells = 42; // 6 weeks x 7 days
  const days = [];

  for (let i = 0; i < totalCells; i++) {
    const d = new Date(firstDay);
    d.setDate(d.getDate() - startDayOfWeek + i);

    // Only include current month, otherwise null
    days.push(d.getMonth() === month ? d : null);
  }

  const todayStr = new Date().toDateString();

  return (
    <div className="month-grid">


      {employees.map(emp => (
        <div key={emp.id} className="month-wrap">
          <div className="employee-col">{emp.first_name} {emp.last_name}</div>

            <div className="month-header">
              {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => (
                <div key={d} className="month-day-name">{d}</div>
              ))}
            </div>


          <div className="month-row">


          {days.map((d, i) => {
            if (!d) return <div key={i} className="month-cell empty" />;

            const hasShift = assignments.some(
              a => a.employee_id === emp.id && new Date(a.shift_date).toDateString() === d.toDateString()
            );

            return (
              <div key={i} className={`month-cell ${d.toDateString() === todayStr ? "today" : ""}`}>
                <span className="date">{d.getDate()}</span>
                {hasShift && <div className="shift-dot" />}
              </div>
            );
          })}
        </div>
        </div>
      ))}
    </div>
  );
};

export default MonthGrid;
